import type { SVGProps } from "react";

export function ENSApiIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height="28"
      viewBox="0 0 28 28"
      width="28"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        fill="#a5e02b"
        height="26"
        rx="3"
        stroke="#000"
        strokeWidth="2"
        width="26"
        x="1"
        y="1"
      />
      <g fill="#074531">
        <path d="m10.4005 7.90039h-1.08013c-.69584.00004-1.25976.56391-1.25976 1.25977v2.70024c-.0001.8431-.34264 1.6057-.89453 2.1591.55217.5535.89443 1.3167.89453 2.1602v2.7002c0 .6958.56392 1.2597 1.25976 1.2597h1.08013v1.8008h-1.08013c-1.68995 0-3.05957-1.3706-3.05957-3.0605v-2.7002c-.00019-.6956-.56514-1.2596-1.26074-1.2598v-1.7998l.12891-.0068c.6351-.0648 1.13166-.6009 1.13183-1.2529v-2.70024c0-1.68997 1.36962-3.06051 3.05957-3.06055h1.08013z" />
        <path d="m18.6797 6.09961c1.69.00004 3.0596 1.37058 3.0596 3.06055v2.70024c.0002.6955.5652 1.2595 1.2608 1.2597v1.7998c-.6956.0002-1.2606.5642-1.2608 1.2598v2.7002c0 1.6899-1.3696 3.0605-3.0596 3.0605h-1.08v-1.8008h1.08c.6959 0 1.2598-.5639 1.2598-1.2597v-2.7002c.0001-.8432.3417-1.6068.8936-2.1602-.5516-.5533-.8935-1.3162-.8936-2.1591v-2.70024c0-.69586-.5639-1.25973-1.2598-1.25977h-1.08v-1.80078z" />
        <path d="m15.9473 9.40234-2.5205 8.99996-1.7324-.4843 2.5195-9.00003z" />
      </g>
    </svg>
  );
}
